export class Actividad {
  public id: number;
  public titulo: string;
  public texto: string;
  public imagen: string;
  public logo: string;
  public contacto: string;
  public lugar: string;
  public horario: string;
  public link: string;

  constructor() { }
}
